module.exports = __webpack_public_path__ + "img/ethos.2c090047.svg";